import { render, staticRenderFns } from "./ReturnExchangeForm.vue?vue&type=template&id=53724d02&scoped=true&"
import script from "./ReturnExchangeForm.vue?vue&type=script&lang=js&"
export * from "./ReturnExchangeForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnExchangeForm.vue?vue&type=style&index=0&id=53724d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53724d02",
  null
  
)

export default component.exports